import React, { useEffect, useState } from 'react'
import BannerLite from '../../media/EarlyAccess/banner-success-guide-lite.png'
import BannerDark from '../../media/EarlyAccess/banner-success-guide-dark.png'
import { useThemeMode } from '../../_metronic/partials'
import { useIntl } from 'react-intl'
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar'
import { useAuth } from '../modules/auth'
import { getSuccessGuide } from '../modules/dashboard/core/_requests'
import { toast } from 'react-toastify'
import { useNavigate } from 'react-router-dom'
import Skeleton from 'react-loading-skeleton'
// import { PaymentDue } from '../modules/dashboard/components/PaymentDue'

const SuccessGuide = () => {
  const { mode } = useThemeMode()
  const { formatMessage } = useIntl()
  const [loading, setLoading] = useState(false)
  const { companyId } = useAuth()
  const [successGuideData, setSuccessGuideData] = useState<any>()
  const [successGuidePercentage, setSuccessGuidePercentage] = useState<number>(0)
  const navigate = useNavigate()

  const getSuccessGuideDetails = async () => {
    try {
      setLoading(true)
      const {
        data: { success, data, errors },
      } = await getSuccessGuide(+companyId!)
      if (success) {
        setSuccessGuideData(data.successGuides)
        const fields = [
          data.successGuides.storage,
          data.successGuides.companyDetails,
          data.successGuides.teamMember,
          data.successGuides.rkChats,
          data.successGuides.categorizedFiles,
          data.successGuides.aiInsights,
        ]

        // Count how many fields are greater than 0
        const completedSteps = fields.filter((value) => value > 0).length

        // Calculate percentage
        const percentage = (completedSteps / 6) * 100

        setSuccessGuidePercentage(percentage)
        setLoading(false)
      } else {
        setLoading(false)
        errors.forEach((error: string) => {
          toast.error(formatMessage({ id: error }))
        })
      }
    } catch (err) {
      setLoading(false)
      console.log(err)
    }
  }

  useEffect(() => {
    if (companyId) {
      getSuccessGuideDetails()
    }
  }, [companyId]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {/* <PaymentDue /> */}
      <div className='bg-white p-md-6 p-4 gap-6 rounded-2 mb-4 mx-md-6 mx-4'>
        {/* banner image  */}
        <div className='shadow-md mb-8'>
          {mode === 'dark' ? (
            <img src={BannerDark} alt='RecordsKeeper AI Early Access' className='w-100' />
          ) : (
            <img src={BannerLite} alt='RecordsKeeper AI Early Access' className='w-100' />
          )}
        </div>

        <div className='row'>
          {/* Progress Card  */}
          <div className='col-md-3'>
            <div className='bg-primary bg-opacity-10 rounded d-flex justify-content-center flex-column align-items-center px-6 py-12'>
              <div
                className='d-flex justify-content-center align-items-center mb-8'
                style={{ width: '128px' }}
              >
                {loading ?
                  <Skeleton
                    height={128}
                    width={128}
                    baseColor='var(--kt-skeleton-bg-color)'
                    highlightColor='var(--kt-skeleton-highlight-bg-color)'
                  />
                  :
                  <CircularProgressbar
                    value={parseFloat(successGuidePercentage.toFixed(2))}
                    text={`${Math.floor(successGuidePercentage)}%`}
                    strokeWidth={18}
                    styles={buildStyles({
                      strokeLinecap: 'round',
                      textSize: '16px',
                      pathTransitionDuration: 0.5,
                      pathColor:
                        parseFloat(successGuidePercentage.toFixed(2)) >= 90 ? '#50CD89' : '#4776E6',
                      textColor: mode === 'dark' ? 'White' : 'Black',
                      trailColor: mode === 'dark' ? '#4A6FA6' : '#D6ECFD',
                    })}
                  />}
              </div>

              <div className=''>
                <p className='mb-0 text-dark text-center fw-semibold font-size-20'>
                  {formatMessage({ id: '🚀' })} <br /> {formatMessage({ id: 'Get Started' })}
                  <br /> {formatMessage({ id: 'With RecordsKeeper.AI' })}
                </p>

                <p className='text-center fw-medium font-size-12 mt-4'>
                  {formatMessage({
                    id: `Follow these simple steps to unlock the full power of RecordsKeeper.AI.`,
                  })}
                </p>

                <p className='text-center fw-regular font-size-12 mt-8'>
                  {formatMessage({
                    id: `You'll be amazed at how effortlessly AI can help you save time, reduce hassle, and maximize efficiency.`,
                  })}
                </p>
              </div>
            </div>
          </div>

          {/* Steps Accordion  */}
          <div className='col-md-9 mt-md-0 mt-4'>
            {loading ?
              [...Array(6)].map((_, index) => (
                <Skeleton
                  key={index}
                  height={63}
                  className='mb-1'
                  width="100%"
                  baseColor="var(--kt-skeleton-bg-color)"
                  highlightColor="var(--kt-skeleton-highlight-bg-color)"
                />
              ))
              :
              <div className='accordion lp-accordion' id='accordionExample'>
                {/* Accodion Item 1  */}
                <div className='accordion-item mb-2 w-100'>
                  <h2 className='accordion-header' id='heading-0'>
                    <button
                      className='accordion-button p-3'
                      style={{ backgroundColor: 'rgba(71, 118, 230, 0.04)' }}
                      type='button'
                      data-bs-toggle='collapse'
                      data-bs-target='#collapse-0'
                      aria-expanded='false'
                      aria-controls='collapse-0'
                    >
                      <div className='d-flex flex-md-row flex-column w-100 pe-md-8 pe-0'>
                        <div className='w-100 d-flex align-items-center gap-4'>
                          {/* count steps  */}
                          <div
                            className='bg-primary text-white rounded-2 font-size-16 d-flex align-items-center justify-content-center p-4'
                            style={{ height: '44px', width: '44px' }}
                          >
                            {formatMessage({ id: '1' })}
                          </div>

                          {/* header and subtext  */}
                          <div className='w-75 w-md-auto'>
                            <h1
                              className={`font-size-14 fw-semibold mb-2 ${successGuideData?.storage > 0 ? 'text-decoration-line-through' : ''
                                }`}
                            >
                              {formatMessage({ id: `Connect Your First Storage` })}
                            </h1>
                            <p className='mb-md-0 mb-2 text-muted font-size-12'>
                              {formatMessage({
                                id: `More storage enhance AI file organization and analysis`,
                              })}
                            </p>
                          </div>
                        </div>

                        {/* Task Progress  */}
                        <div className='d-flex flex-column gap-2 mb-1 w-md-50 w-auto px-md-8 px-0 pt-2 pt-md-0'>
                          <p className='mb-0 font-size-12 text-dark'>
                            {formatMessage({ id: `Task ` })}
                            {`(${successGuideData?.storage > 0 ? 1 : 0}/1)`}
                          </p>
                          <div className='h-10px progress border border-2 border-muted'>
                            <div
                              className='progress-bar bg-success'
                              role='progressbar'
                              style={{
                                width: `${successGuideData?.storage > 0 ? 100 : 0}%`, // Ensure percentage
                              }}
                            ></div>
                          </div>
                        </div>
                      </div>
                    </button>
                  </h2>

                  {/* items collapes  content  */}
                  <div
                    id='collapse-0'
                    className='accordion-collapse collapse'
                    aria-labelledby='heading-0'
                    data-bs-parent='#accordionExample'
                  >
                    <div
                      className='accordion-body p-3 text-dark'
                      style={{ backgroundColor: 'rgba(71, 118, 230, 0.08)' }}
                    >
                      <div className='d-flex flex-md-row flex-column gap-md-8 gap-3 align-items-center justify-content-between'>
                        <p className='mb-0 w-auto'>
                          {formatMessage({
                            id: `Link at least one storage provider i.e Google Drive, Dropbox, OneDrive, etc.
                      to start syncing your records`,
                          })}
                        </p>

                        <button
                          className={`btn w-100 w-md-auto ${successGuideData?.storage > 0 ? 'btn-success' : 'btn-primary'
                            } text-white`}
                          onClick={() => navigate('/rk/sources-and-sync')}
                          disabled={successGuideData?.storage > 0}
                        >
                          {successGuideData?.storage > 0 ? 'Completed' : 'Connect'}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Accodion Item 2  */}
                <div className='accordion-item mb-2 w-100'>
                  <h2 className='accordion-header' id='heading-1'>
                    <button
                      className='accordion-button p-3'
                      style={{ backgroundColor: 'rgba(71, 118, 230, 0.04)' }}
                      type='button'
                      data-bs-toggle='collapse'
                      data-bs-target='#collapse-1'
                      aria-expanded='false'
                      aria-controls='collapse-1'
                    >
                      <div className='d-flex flex-md-row flex-column w-100 pe-md-8 pe-0'>
                        <div className='w-100 d-flex align-items-center gap-4'>
                          {/* count steps  */}
                          <div
                            className='bg-primary text-white rounded-2 font-size-16 d-flex align-items-center justify-content-center p-4'
                            style={{ height: '44px', width: '44px' }}
                          >
                            {formatMessage({ id: '2' })}
                          </div>

                          {/* header and subtext  */}
                          <div className='w-75 w-md-auto'>
                            <h1
                              className={`font-size-14 fw-semibold mb-2 ${successGuideData?.companyDetails > 0
                                ? 'text-decoration-line-through'
                                : ''
                                }`}
                            >
                              {formatMessage({ id: `Update Your Company Details` })}
                            </h1>

                            <p className='mb-md-0 mb-2 text-muted font-size-12'>
                              {formatMessage({
                                id: `Navigate to Company Profile and fill in essential details`,
                              })}
                            </p>
                          </div>
                        </div>

                        {/* Task Progress  */}
                        <div className='d-flex flex-column gap-2 mb-1 w-md-50 w-auto px-md-8 px-0 pt-2 pt-md-0'>
                          <p className='mb-0 font-size-12 text-dark'>
                            {formatMessage({ id: `Task ` })}
                            {`(${successGuideData?.companyDetails > 0 ? 1 : 0}/1)`}
                          </p>
                          <div className='h-10px progress border border-2 border-muted'>
                            <div
                              className='progress-bar bg-success'
                              role='progressbar'
                              style={{
                                width: `${successGuideData?.companyDetails > 0 ? 100 : 0}%`, // Ensure percentage
                              }}
                            ></div>
                          </div>
                        </div>
                      </div>
                    </button>
                  </h2>

                  {/* items collapes  content  */}
                  <div
                    id='collapse-1'
                    className='accordion-collapse collapse'
                    aria-labelledby='heading-1'
                    data-bs-parent='#accordionExample'
                  >
                    <div
                      className='accordion-body p-3 text-dark'
                      style={{ backgroundColor: 'rgba(71, 118, 230, 0.08)' }}
                    >
                      <div className='d-flex flex-md-row flex-column gap-md-8 gap-3 align-items-center justify-content-between'>
                        <p className='mb-0 w-auto'>
                          {formatMessage({
                            id: `Update Company Name, Industry, Contact Information, Logo (for a branded
                      experience)`,
                          })}
                        </p>

                        <button
                          className={`btn w-100 w-md-auto ${successGuideData?.companyDetails > 0 ? 'btn-success' : 'btn-primary'
                            } text-white`}
                          onClick={() => navigate('/setting/company-settings?tab=general')}
                          disabled={successGuideData?.companyDetails > 0}
                        >
                          {successGuideData?.companyDetails > 0 ? 'Completed' : 'Update'}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Accodion Item 3  */}
                <div className='accordion-item mb-2 w-100'>
                  <h2 className='accordion-header' id='heading-2'>
                    <button
                      className='accordion-button p-3'
                      style={{ backgroundColor: 'rgba(71, 118, 230, 0.04)' }}
                      type='button'
                      data-bs-toggle='collapse'
                      data-bs-target='#collapse-2'
                      aria-expanded='false'
                      aria-controls='collapse-2'
                    >
                      <div className='d-flex flex-md-row flex-column w-100 pe-md-8 pe-0'>
                        <div className='w-100 d-flex align-items-center gap-4'>
                          {/* count steps  */}
                          <div
                            className='bg-primary text-white rounded-2 font-size-16 d-flex align-items-center justify-content-center p-4'
                            style={{ height: '44px', width: '44px' }}
                          >
                            {formatMessage({ id: '3' })}
                          </div>

                          {/* header and subtext  */}
                          <div className='w-75 w-md-auto'>
                            <h1
                              className={`font-size-14 fw-semibold mb-2 ${successGuideData?.teamMember > 0 ? 'text-decoration-line-through' : ''
                                }`}
                            >
                              {formatMessage({ id: `Add a Team Member` })}
                            </h1>

                            <p className='mb-md-0 mb-2 text-muted font-size-12'>
                              {formatMessage({ id: `Go to Team Settings, add email, assign roles.` })}
                            </p>
                          </div>
                        </div>

                        {/* Task Progress  */}
                        <div className='d-flex flex-column gap-2 mb-1 w-md-50 w-auto px-md-8 px-0 pt-2 pt-md-0'>
                          <p className='mb-0 font-size-12 text-dark'>
                            {formatMessage({ id: `Task ` })}
                            {`(${successGuideData?.teamMember > 0 ? 1 : 0}/1)`}
                          </p>
                          <div className='h-10px progress border border-2 border-muted'>
                            <div
                              className='progress-bar bg-success'
                              role='progressbar'
                              style={{
                                width: `${successGuideData?.teamMember > 0 ? 100 : 0}%`, // Ensure percentage
                              }}
                            ></div>
                          </div>
                        </div>
                      </div>
                    </button>
                  </h2>

                  {/* items collapes  content  */}
                  <div
                    id='collapse-2'
                    className='accordion-collapse collapse'
                    aria-labelledby='heading-2'
                    data-bs-parent='#accordionExample'
                  >
                    <div
                      className='accordion-body p-3 text-dark'
                      style={{ backgroundColor: 'rgba(71, 118, 230, 0.08)' }}
                    >
                      <div className='d-flex flex-md-row flex-column gap-md-8 gap-3 align-items-center justify-content-between'>
                        <p className='mb-0 w-auto'>
                          {formatMessage({
                            id: `Invite colleagues to collaborate on records seamlessly`,
                          })}
                        </p>

                        <button
                          className={`btn w-100 w-md-auto ${successGuideData?.teamMember > 0 ? 'btn-success' : 'btn-primary'
                            } text-white`}
                          onClick={() => navigate('/setting/company-settings?tab=teams')}
                          disabled={successGuideData?.teamMember > 0}
                        >
                          {successGuideData?.teamMember > 0 ? 'Completed' : 'Complete'}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Accodion Item 4  */}
                <div className='accordion-item mb-2 w-100'>
                  <h2 className='accordion-header' id='heading-3'>
                    <button
                      className='accordion-button p-3'
                      style={{ backgroundColor: 'rgba(71, 118, 230, 0.04)' }}
                      type='button'
                      data-bs-toggle='collapse'
                      data-bs-target='#collapse-3'
                      aria-expanded='false'
                      aria-controls='collapse-3'
                    >
                      <div className='d-flex flex-md-row flex-column w-100 pe-md-8 pe-0'>
                        <div className='w-100 d-flex align-items-center gap-4'>
                          {/* count steps  */}
                          <div
                            className='bg-primary text-white rounded-2 font-size-16 d-flex align-items-center justify-content-center p-4'
                            style={{ height: '44px', width: '44px' }}
                          >
                            {formatMessage({ id: '4' })}
                          </div>

                          {/* header and subtext  */}
                          <div className='w-75 w-md-auto'>
                            <h1
                              className={`font-size-14 fw-semibold mb-2 ${successGuideData?.rkChats > 0 ? 'text-decoration-line-through' : ''
                                }`}
                            >
                              {formatMessage({ id: `Interact with Your Records in Chat` })}
                            </h1>
                            <p className='mb-md-0 mb-2 text-muted font-size-12'>
                              {formatMessage({
                                id: `AI improves search accuracy through ongoing interactions`,
                              })}
                            </p>
                          </div>
                        </div>

                        {/* Task Progress  */}
                        <div className='d-flex flex-column gap-2 mb-1 w-md-50 w-auto px-md-8 px-0 pt-2 pt-md-0'>
                          <p className='mb-0 font-size-12 text-dark'>
                            {formatMessage({ id: `Task ` })}
                            {`(${successGuideData?.rkChats > 0 ? 1 : 0}/1)`}
                          </p>
                          <div className='h-10px progress border border-2 border-muted'>
                            <div
                              className='progress-bar bg-success'
                              role='progressbar'
                              style={{
                                width: `${successGuideData?.rkChats > 0 ? 100 : 0}%`, // Ensure percentage
                              }}
                            ></div>
                          </div>
                        </div>
                      </div>
                    </button>
                  </h2>

                  {/* items collapes  content  */}
                  <div
                    id='collapse-3'
                    className='accordion-collapse collapse'
                    aria-labelledby='heading-3'
                    data-bs-parent='#accordionExample'
                  >
                    <div
                      className='accordion-body p-3 text-dark'
                      style={{ backgroundColor: 'rgba(71, 118, 230, 0.08)' }}
                    >
                      <div className='d-flex flex-md-row flex-column gap-md-8 gap-3 align-items-center justify-content-between'>
                        <p className='mb-0 w-auto'>
                          {formatMessage({
                            id: `Use AI Chat to ask questions and retrieve records instantly`,
                          })}
                        </p>

                        <button
                          className={`btn w-100 w-md-auto ${successGuideData?.rkChats > 0 ? 'btn-success' : 'btn-primary'
                            } text-white`}
                          onClick={() => navigate('/query-and-prompt')}
                          disabled={successGuideData?.rkChats > 0}
                        >
                          {successGuideData?.rkChats > 0 ? 'Completed' : 'Chat Now'}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Accodion Item 5  */}
                <div className='accordion-item mb-2 w-100'>
                  <h2 className='accordion-header' id='heading-4'>
                    <button
                      className='accordion-button p-3'
                      style={{ backgroundColor: 'rgba(71, 118, 230, 0.04)' }}
                      type='button'
                      data-bs-toggle='collapse'
                      data-bs-target='#collapse-4'
                      aria-expanded='false'
                      aria-controls='collapse-4'
                    >
                      <div className='d-flex flex-md-row flex-column w-100 pe-md-8 pe-0'>
                        <div className='w-100 d-flex align-items-center gap-4'>
                          {/* count steps  */}
                          <div
                            className='bg-primary text-white rounded-2 font-size-16 d-flex align-items-center justify-content-center p-4'
                            style={{ height: '44px', width: '44px' }}
                          >
                            {formatMessage({ id: '5' })}
                          </div>

                          {/* header and subtext  */}
                          <div className='w-75 w-md-auto'>
                            <h1
                              className={`font-size-14 fw-semibold mb-2 ${successGuideData?.categorizedFiles > 0
                                ? 'text-decoration-line-through'
                                : ''
                                }`}
                            >
                              {formatMessage({ id: `Browse Categorized Files` })}
                            </h1>

                            <p className='mb-md-0 mb-2 text-muted font-size-12'>
                              {formatMessage({ id: `Quickly locate records without manual tagging` })}
                            </p>
                          </div>
                        </div>

                        {/* Task Progress  */}
                        <div className='d-flex flex-column gap-2 mb-1 w-md-50 w-auto px-md-8 px-0 pt-2 pt-md-0'>
                          <p className='mb-0 font-size-12 text-dark'>
                            {formatMessage({ id: `Task ` })}
                            {`(${successGuideData?.categorizedFiles > 0 ? 1 : 0}/1)`}
                          </p>
                          <div className='h-10px progress border border-2 border-muted'>
                            <div
                              className='progress-bar bg-success'
                              role='progressbar'
                              style={{
                                width: `${successGuideData?.categorizedFiles > 0 ? 100 : 0}%`, // Ensure percentage
                              }}
                            ></div>
                          </div>
                        </div>
                      </div>
                    </button>
                  </h2>

                  {/* items collapes  content  */}
                  <div
                    id='collapse-4'
                    className='accordion-collapse collapse'
                    aria-labelledby='heading-4'
                    data-bs-parent='#accordionExample'
                  >
                    <div
                      className='accordion-body p-3 text-dark'
                      style={{ backgroundColor: 'rgba(71, 118, 230, 0.08)' }}
                    >
                      <div className='d-flex flex-md-row flex-column gap-md-8 gap-3 align-items-center justify-content-between'>
                        <p className='mb-0 w-auto'>
                          {formatMessage({ id: `Use filters to sort and refine your document view.` })}
                        </p>

                        <button
                          className={`btn w-100 w-md-auto ${successGuideData?.categorizedFiles > 0 ? 'btn-success' : 'btn-primary'
                            } text-white`}
                          onClick={() => navigate('/rk/records-and-files')}
                          disabled={successGuideData?.categorizedFiles > 0}
                        >
                          {successGuideData?.categorizedFiles > 0 ? 'Completed' : 'Complete'}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Accodion Item 6  */}
                <div className='accordion-item mb-2 w-100'>
                  <h2 className='accordion-header' id='heading-5'>
                    <button
                      className='accordion-button p-3'
                      style={{ backgroundColor: 'rgba(71, 118, 230, 0.04)' }}
                      type='button'
                      data-bs-toggle='collapse'
                      data-bs-target='#collapse-5'
                      aria-expanded='false'
                      aria-controls='collapse-5'
                    >
                      <div className='d-flex flex-md-row flex-column w-100 pe-md-8 pe-0'>
                        <div className='w-100 d-flex align-items-center gap-4'>
                          {/* count steps  */}
                          <div
                            className='bg-primary text-white rounded-2 font-size-16 d-flex align-items-center justify-content-center p-4'
                            style={{ height: '44px', width: '44px' }}
                          >
                            {formatMessage({ id: '6' })}
                          </div>

                          {/* header and subtext  */}
                          <div className='w-75 w-md-auto'>
                            <h1
                              className={`font-size-14 fw-semibold mb-2 ${successGuideData?.aiInsights > 0 ? 'text-decoration-line-through' : ''
                                }`}
                            >
                              {formatMessage({ id: `Open a File & Explore AI Insights` })}
                            </h1>

                            <p className='mb-md-0 mb-2 text-muted font-size-12'>
                              {formatMessage({ id: `AI insights save time by highlighting key details` })}
                            </p>
                          </div>
                        </div>

                        {/* Task Progress  */}
                        <div className='d-flex flex-column gap-2 mb-1 w-md-50 w-auto px-md-8 px-0 pt-2 pt-md-0'>
                          <p className='mb-0 font-size-12 text-dark'>
                            {formatMessage({ id: `Task ` })}
                            {`(${successGuideData?.aiInsights > 0 ? 1 : 0}/1)`}
                          </p>
                          <div className='h-10px progress border border-2 border-muted'>
                            <div
                              className='progress-bar bg-success'
                              role='progressbar'
                              style={{
                                width: `${successGuideData?.aiInsights > 0 ? 100 : 0}%`,
                              }}
                            ></div>
                          </div>
                        </div>
                      </div>
                    </button>
                  </h2>

                  {/* items collapes  content  */}
                  <div
                    id='collapse-5'
                    className='accordion-collapse collapse'
                    aria-labelledby='heading-5'
                    data-bs-parent='#accordionExample'
                  >
                    <div
                      className='accordion-body text-dark'
                      style={{ backgroundColor: 'rgba(71, 118, 230, 0.08)' }}
                    >
                      <div className='d-flex flex-md-row flex-column gap-md-8 gap-3 align-items-center justify-content-between'>
                        <p className='mb-0 w-auto'>
                          {formatMessage({
                            id: `Click on any document to view AI-generated summaries, key highlights, and
                      extracted data.`,
                          })}
                        </p>

                        <button
                          className={`btn w-100 w-md-auto ${successGuideData?.aiInsights > 0 ? 'btn-success' : 'btn-primary'
                            } text-white`}
                          onClick={() => navigate('/rk/records-and-files/files-details')}
                          disabled={successGuideData?.aiInsights > 0}
                        >
                          {successGuideData?.aiInsights > 0 ? 'Completed' : 'Explore'}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>
    </>

  )
}

export default SuccessGuide
